import { useEffect } from 'react';

const FOCUSABLE = 'button, a[href], input, select, textarea, [tabindex]';

// The desktop navigation is not modal. Only the open phone drawer owns focus.
export default function useMobileNavigationDrawer({ open, drawerRef, triggerRef, onClose }) {
  useEffect(() => {
    const drawer = drawerRef.current;
    if (!open || !drawer) return undefined;
    const returnTarget = triggerRef.current || document.activeElement;
    const choices = () => [...drawer.querySelectorAll(FOCUSABLE)].filter((element) => (
      !element.disabled && element.tabIndex >= 0 && !element.closest('[inert]')
      && element.getClientRects().length > 0
    ));
    (choices()[0] || drawer).focus();

    const handleKey = (event) => {
      // A portal dialog opened above navigation retains its own key handling.
      if (event.target instanceof Element && event.target.closest('[role="dialog"]') && !drawer.contains(event.target)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      } else if (event.key === 'Tab') {
        const items = choices();
        const first = items[0] || drawer;
        const last = items[items.length - 1] || drawer;
        if (!drawer.contains(document.activeElement) || document.activeElement === drawer
          || (!event.shiftKey && document.activeElement === last)
          || (event.shiftKey && document.activeElement === first)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    };
    document.addEventListener('keydown', handleKey, true);
    return () => {
      document.removeEventListener('keydown', handleKey, true);
      if (returnTarget?.isConnected && !returnTarget.closest('[inert]')) returnTarget.focus();
    };
  }, [open, drawerRef, triggerRef, onClose]);
}
